import { faChevronDown } from "@fortawesome/free-solid-svg-icons"
import { faPlus } from "@fortawesome/pro-light-svg-icons"
import { Button, Dropdown } from "@joonapp/web-shared"

import { useQuestModalStore } from "./useQuestModalStore"
import useAddEditScheduledMessageModalStore from "./useScheduledMessageModalStore"
import useUserRole from "../../../hooks/useUserRole"
import { trackAnalyticEvent } from "../../../util/analytics"
import { ANALYTIC_EVENTS } from "../../../util/analytics"

const CreateButtonDropdown = () => {
  const { onOpen: openAddScheduledMessageModal } =
    useAddEditScheduledMessageModalStore()
  const { onOpen: openAddQuestModal } = useQuestModalStore()
  const { isClientOfOtherCoach } = useUserRole()

  return (
    <Dropdown
      trigger={
        <Button
          size="medium"
          text="Create"
          icon={faPlus}
          rightIcon={faChevronDown}
          disabled={isClientOfOtherCoach}
        />
      }
      items={[
        {
          label: "Task",
          value: "task",
          onClick: () => {
            if (isClientOfOtherCoach) return
            openAddQuestModal()
          },
        },
        {
          label: "Scheduled message",
          value: "scheduled-message",
          onClick: () => {
            if (isClientOfOtherCoach) return
            openAddScheduledMessageModal()
            trackAnalyticEvent(ANALYTIC_EVENTS.OPEN_ADD_SCHEDULED_MESSAGE, {
              source: "create_button_dropdown",
            })
          },
        },
      ]}
    />
  )
}
export default CreateButtonDropdown
